<script setup lang="ts">
import { AssetType } from '~/apiClient';

// COMPOSABLES
const { formatSlpRoute } = useSlpRouteUtils();
const { onSlpFilterChangeByKey } = useTracking();
const { tt } = useTypedI18n();
const sellingMethod = useSlpSellingMethod();
const {
    // Filters
    brandId,
    brandName,
    modelId,

    // Options
    brandsOptions,
    modelsOptions,
} = useSlpParams(sellingMethod);

// DATA
const brandIdSelectModel = adaptEmptyOptionModel(brandId);
const brandNameSelectModel = adaptEmptyOptionModel(brandName);
const modelIdSelectModel = adaptEmptyOptionModel(modelId);

const brandsSelectOptions = computed(() => prependEmptyOption(brandsOptions.value, tt('slp.filters.brandFilterAnyOption')));
const modelsSelectOptions = computed(() => prependEmptyOption(modelsOptions.value, tt('slp.filters.modelFilterAnyOption')));
</script>

<template>
    <UFormField :label="tt('slp.filters.brandFilter')" class="sm:grow">
        <USelectMenu
            v-model="brandIdSelectModel"
            :disabled="brandsOptions.length === 0"
            :items="brandsSelectOptions"
            value-key="value"
            @update:model-value="onSlpFilterChangeByKey('brand', brandsSelectOptions, $event)"
        />
        <template v-for="brand in brandsOptions" :key="brand.value">
            <NuxtLinkLocale
                :to="
                    formatSlpRoute({
                        sellingMethod,
                        assetType: AssetType.Bus,
                        brandUrlKey: brand.urlKey,
                    })
                "
                class="hidden"
            >
                {{ brand.label }}
            </NuxtLinkLocale>
        </template>
    </UFormField>
    <UFormField :label="tt('slp.filters.modelFilter')" class="sm:grow">
        <USelectMenu
            v-model="modelIdSelectModel"
            :disabled="!brandIdSelectModel || modelsOptions.length === 0"
            :items="modelsSelectOptions"
            value-key="value"
            @update:model-value="onSlpFilterChangeByKey('model', modelsSelectOptions, $event)"
        />
        <template v-if="!!brandIdSelectModel">
            <template v-for="model in modelsOptions" :key="model.value">
                <NuxtLinkLocale
                    :to="
                        formatSlpRoute({
                            sellingMethod,
                            assetType: AssetType.Bus,
                            brandUrlKey: model.brandUrlKey,
                            modelUrlKey: model.urlKey,
                        })
                    "
                    class="hidden"
                >
                    {{ brandNameSelectModel }} {{ model.label }}
                </NuxtLinkLocale>
            </template>
        </template>
    </UFormField>
</template>
